module.exports = __webpack_public_path__ + "img/dd.0fdfb837.webp";